var classes = {
    FLOATING_LABEL: 'tyl-floating-label',
    FLOAT: 'tyl-floating-label--float'
};
export var FLOATING_LABEL_CONSTANTS = {
    classes: classes
};
